module.exports = __webpack_public_path__ + "img/auto_texts_active.1bf1585f.svg";